
import { Link, useLocation } from 'react-router-dom'
import Resume from '../resources/Nick Amenda Resume.pdf'

const Navbar = () => {

  const openMenu = () => {
    var x = document.getElementById("myNavbar");
    if (x.className === "navbar") {
      x.className += " responsive";
    } else {
      x.className = "navbar";
    }
    var y = document.getElementById("myLinks");
    if (y.className === "links") {
      y.className += " responsive";
    } else {
      y.className = "links";
    }
  };
  
  const closeMenu = () => {
    document.getElementById("myLinks").className = "links"
  }

  return (
    <>
      <div className="navbar" id="myNavbar" >
        <Link to="/" onClick={closeMenu}>
          {/* <img className="logo" src={logo} alt="my logo"></img> */}
        </Link>
        <div className="links" id="myLinks">
          <Link to="/" onClick={closeMenu}>
            <section>00.</section>Home
          </Link>
          <Link to="/about" onClick={closeMenu}>
            <section>01.</section>About
          </Link>
          <Link to="/projects" onClick={closeMenu}>
            <section>02.</section>Projects
          </Link>
          <Link to="/work" onClick={closeMenu}>
            <section>03.</section>Experience
          </Link>
          <Link to="/contact" onClick={closeMenu}>
            <section>04.</section>Contact Me!
          </Link>
          <a className="resume" href={Resume} target="_blank" rel="noreferrer" onClick={closeMenu}>
            Resume
          </a>
        </div>
        <a href="#" className="icon" onClick={(e) => {
          e.preventDefault()
          openMenu()
        }}>
          <div className="fa fa-bars">&#9776;</div>
        </a>
      </div>
    </>
  )
}

export default Navbar;
